import React, { Component } from 'react';

import './Header.css'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getFaqContent } from '../../containers/actions';
import styled from 'styled-components';
import { Body, Title } from '@vds/typography';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Row, Col } from '@vds/grids';
import { Button } from '@vds/buttons';
import { MarginSpacerL, MarginSpacerXL, MarginSpacerS, MarginSpacerM, MarginTopSpacerL,MarginTopSpacerM } from '../../Pages/Checkout/styleTag';
import { StickyHeader } from "@vds/layout";
import { loadFloatingCart } from '../FloatingCart/containers/actions';

const CustomDiv = styled.div`
    padding-right: 10px;
`;
const CustomFaqDiv = styled.div`
    padding-right: 10px;
    @media (max-width: 768px) {
    margin-bottom: 10px;
    }
`;
const RedirectModal = styled(Modal)`
height: auto;
@media only screen and (max-width: 600px) {
    position: absolute;
    top: 10px;
    right:10px;
    left:10px;
    width: 90%;
    height: 97vh;
    > div:first-child {
        padding:2px;
    }
}
> div:first-child {overflow:hidden}
`;

const ButtonWrapper = styled.div`
  display: flex;
  button {
    margin: 16px 16px 16px 0;
    width :176px;

  }
  padding-left: 50px;
  @media (min-width: 768px) {
    justify-content: flex-start;
  }
  @media (max-width: 768px) {
    button {
      justify-content: center;
      width: 100%;
    }
  }
`;

const FAQModal = styled(Modal)` 
padding: 15px
> div:first-child {overflow:hidden}
`;

const FAQModalBody = styled(ModalBody)`
    overflow-x: auto;
    height: 20rem;
`
class Myservices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            faqModal: false

        }
    }
    handleClickEvent = () => alert();

    handleFaq = () => {
        this.props.getFaqContent({ pageName: 'CHECKOUT', sectionName: '' });
    }
    openFaqModal() {
        this.setState({ faqModal: true })
    }
    closeFaqModal = () => {
        this.setState({ faqModal: false })
    };

    faqModalChange = (viewFaqModal) => {
        this.setState({ faqModal: viewFaqModal })
    };

    renderModal = () => {
        // const pathName = window.location.pathname.toLowerCase();
        // if(pathName  === '/foryoursmallbiz/internetqualification/' || 
        //         pathName=== '/foryoursmallbiz/internetqualification' || 
        //         pathName === '/foryoursmallbiz/internet/' ||
        //         pathName === '/foryoursmallbiz/internet'
        //       ) {
            
        // return (<FAQModal
        //     ariaLabel=""
        //     opened={this.state.faqModal}
        //     onOpenedChange={this.faqModalChange}
        //     zIndex={9999}
        //     disableOutsideClick={true}
        // >
        //     <ModalTitle><Title size="small" primitive="h2">FAQs</Title></ModalTitle>
        //     <ModalBody>
        //         <Body size="medium" primitive="h2"></Body>
        //         <MarginSpacerXL></MarginSpacerXL>
        //         <Body size="medium" bold primitive="h2">Entering your address.</Body>
        //         <MarginSpacerS></MarginSpacerS>
        //         <Body size="medium" primitive="h2">
        //         <div className="OrdersList">
        //                 <ul className="Modal_Orderlist1">
        //              <li class="margin-bottom-tiny">Check the spelling of your street address (e.g. John F Kennedy vs. JF Kennedy).</li>
        //              <li class="margin-bottom-tiny">Use the complete street address, even with words like "Drive, Avenue," etc. when it's in the name.</li>
        //              <li class="margin-bottom-tiny"> If your street has a direction before the street name (N, S, E, W, etc.), you should include the abbreviation before the street name (e.g., 240 S Graham Street).</li>
        //              <li class="margin-bottom-tiny"> If your street has a direction after the street name (N, S, E, W, etc.), you should include the abbreviation after the street name (e.g., 1729 First Street NW).</li>
        //              <li class="margin-bottom-zero">Make sure you're using an actual street address, not a P.O. box.</li>
        //              </ul>
        //             </div>

        //         </Body>
        //         <MarginTopSpacerL></MarginTopSpacerL>
        //         <Body size="medium" bold primitive="h2">Entering your unit type and/or number.</Body>
        //         <MarginSpacerS></MarginSpacerS>
        //         {/* <Body size="medium" primitive="h2">The following is required for you to submit an order:</Body> */}
        //         <MarginSpacerM></MarginSpacerM>
        //         <Body size="medium" primitive="h2">
        //             <div className="OrdersList">
        //                 <ul className="Modal_Orderlist1">
        //                     <li>If you live in an apartment with several floors and apartments, please include your floor and apartment number (e.g., Flr 1 Apt C).</li>
        //                     {/* <MarginSpacerS></MarginSpacerS> */}
        //                     <li>If you live in a building or complex with several different units, please include the building and/or apartment number (e.g., Bldg P Apt 21). </li>
        //                     {/* <MarginSpacerS></MarginSpacerS> */}
        //                     <li>Use spaces between numbers and letters (e.g., Bldg P Apt 3 A).</li>
        //                 </ul>
        //             </div>
        //         </Body>
        //         <MarginTopSpacerL></MarginTopSpacerL>
        //         <Body size="medium" bold primitive="h2">Get help with something else.</Body>
        //         <MarginSpacerS></MarginSpacerS>
        //         <Body size="medium" primitive="h2">Give us a call and we'll get it sorted out, together</Body>
        //         <MarginSpacerL></MarginSpacerL>
        //         <Body size="medium" bold primitive="h2">1-800-VERIZON (1-800-837-4966).</Body>
        //     </ModalBody>
        // </FAQModal>);
        // }
        return (<FAQModal
            ariaLabel=""
            opened={this.state.faqModal}
            onOpenedChange={this.faqModalChange}
            zIndex={9999}
            disableOutsideClick={true}
        >
            <ModalTitle><Title size="large"  primitive="h2">Frequently asked questions</Title></ModalTitle>
            <FAQModalBody>
                <MarginTopSpacerM></MarginTopSpacerM>
                <Body size="large" bold primitive="h2">Can I save my order?</Body>
                <MarginSpacerS></MarginSpacerS>
                <Body size="medium" primitive="h2">Yes, you can save your order by clicking on Save Cart. If you are a new customer,
                we will prompt you for your email so we can send you an email with a link to your saved cart. If you are an existing customer,
          you can log into your account to return to your saved cart.</Body>
                <MarginTopSpacerL></MarginTopSpacerL>
                <Body size="large" bold primitive="h2">What will I need to submit my order?</Body>
                <MarginSpacerS></MarginSpacerS>
                <Body size="medium" primitive="h2">The following is required for you to submit an order:</Body>
                <MarginSpacerM></MarginSpacerM>
                <Body size="medium" primitive="h2">
                    <div className="OrdersList">
                        <ul className="Modal_Orderlist1">
                            <li>Exact address for the service</li>
                            <MarginSpacerS></MarginSpacerS>
                            <li>When ready, you will be required to submit a credit application. For sole
                            owners, a personal credit check will be completed on your name and Social
                            Security Number. If you are a Corporation, you will be required to provide the
legal Corporate name and Tax ID number </li>
                            <MarginSpacerS></MarginSpacerS>
                            <li>Depending on the credit application results, you may be required to make a
refundable deposit, or to speak to a representative.</li>
                        </ul>
                    </div>
                </Body>
                <MarginTopSpacerL></MarginTopSpacerL>
                <Body size="large" bold primitive="h2">When can I expect my new service?</Body>
                <MarginSpacerS></MarginSpacerS>
                <Body size="medium" primitive="h2">During checkout you can select the date and time that works best for you based
on availability.</Body>
                <MarginSpacerL></MarginSpacerL>
                <Body size="large" bold primitive="h2">Do I have to pay installation on my ﬁrst bill?</Body>
                <MarginSpacerS></MarginSpacerS>
                <Body size="medium" primitive="h2">You will receive your first bill between two to three weeks after your service is
                connected. Depending on what you selected during Checkout, your bill may
                include one-time (non-recurring) charges or monthly, recurring charges to pay
for any equipment you may have ordered.</Body>
            </FAQModalBody>
        </FAQModal>);

    };


    showModal = () => {
        /*  TODO: loadFloatingCart IS FOR TESTING , REMOVE AFTER DEV AND UNCOMMENT BELOW LINES */
        // this.props.loadFloatingCart();
        // VBGVK-86 - removing redirection stopper modal
        // if(!this.props.savedCartError && (this.props.location.pathname =="/customize-order" ||this.props.location.pathname =="/checkout") ){
        // this.setState({
        //     openModal: true
        // })} else{
            window.location="https://www.verizon.com/business/small-medium/" ;
        // }
        
    }
    closeModal = (modal) => {
        this.setState({
            openModal: modal
        })
    }
    btnHandler = (value) => {
        this.setState({
            openModal: false
        })
        if (value == true) {
            this.props.history.push('/save-cart')
        }
        else {
            window.location = "https://www.verizon.com/business/small-medium/"
        }

    }


    render() {
        return (
            <div id='gh-container'>
                <StickyHeader stuck={true} offset={this.state.stickyPos}>
                    <header id="gh-accessebility" className="top-header">
                        <div className="global-header">
                            <div className="gh-left gh-item">
                                <div>
                                    <a href="https://www.verizon.com/about/fios-accessibility-services" tabIndex="0" className="header-accessibility">Accessibility Services
				                </a>
                                    <a href="#content" tabIndex="0" className="header-accessibility" id="skipToMainContentId" >Skip to main content
				                </a>
                                </div>
                                <div className="gh-logo" id="logo">
                                    <a id="logo-url" onClick={() => this.showModal()} >
                                        <img alt="verizon-logo" src="https://www.verizon.com/content/dam/verizon/global/v-logo.svg" />
                                    </a>
                                </div>
                            </div>
                            <div className="gh-right gh-item">
                                <nav className="gh-left-nav animate">
                                    {/* <ul className="lob">
                                    <li>
                                        <a href="https://www.verizonwireless.com/?intcmp=VZ-GHOME-D-WIRELESS" >Wireless</a>
                                    </li>
                                    <li>
                                        <a href="https://www.verizon.com/?lid=//global//residential" >In Home</a>
                                    </li>
                                    <li className="li-active">
                                        <a href="https://www.verizon.com/business/gateway/" >Business</a>
                                    </li></ul> */}
                                    <nav className="gh-left-nav gh-nav">
                                        <ul id="mainNav" className="gh-nav"></ul>
                                        <div className="underlay"></div>
                                    </nav>
                                </nav>
                                <div className="gh-right-tools">
                                    <div className="second-floor"></div>
                                    <div className="first-floor">
                                        <div className="gh-account">
                                        <span>
                                            <CustomFaqDiv>
                                                    <Body size="small" primitive="span">
                                                     { !this.props.savedCartError  && <a onClick={() => this.openFaqModal(true)}>FAQs</a>}
                                                    </Body>
                                                </CustomFaqDiv>
                                            </span>
                                            {/*<div>
                                                 <CustomDiv>
                                                    <Body size="small" primitive="span">Sales: 1-877-246-9977</Body>
                                                </CustomDiv>
                                                <CustomDiv>
                                                    <Body size="small" primitive="span">Request contact</Body>
                                                </CustomDiv> 
                                                <CustomFaqDiv>
                                                    <Body size="small" primitive="span">
                                                        <a onClick={() => this.openFaqModal(true)}>FAQs</a>
                                                    </Body>
                                                </CustomFaqDiv>
                                            </div>*/}
                                            {/* <span className="hamburger-icon" onClick={() => this.setState({ openMenu: !this.state.openMenu })}>
                                                <MdViewHeadline />
                                            </span> 
                                            <div className="menu account-menu"></div>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </StickyHeader>
                <RedirectModal
                        ariaLabel=""
                        opened={this.state.openModal}
                        zIndex={9999}
                        disableOutsideClick={true}
                        onOpenedChange={this.closeModal}>
                        <ModalTitle>
                            <Title size="small" primitive="h2">We will save your cart and send you an email with a link so you can continue where
                  you left off. Do you want to save the cart?</Title>
                        </ModalTitle>
                        <ModalBody>
                            <div>
                                <ButtonWrapper>
                                    <Button onClick={() => this.btnHandler()}  >No</Button>
                                    <Button secondary width="100%" onClick={() => this.btnHandler(true)} >Save cart</Button>
                                </ButtonWrapper>

                            </div>
                        </ModalBody>
                    </RedirectModal>
                {this.state.faqModal && this.renderModal()}
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    const { CheckoutPage } = state;

	return { 
		savedCartError: CheckoutPage.savedCartError,
	}
 };

const mapDispatchToProps = (dispatch) => ({
    getFaqContent: (data) => dispatch(getFaqContent(data)),
    loadFloatingCart: () => dispatch(loadFloatingCart())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Myservices))
